/**
 * Generic helpers for static files under public/resources/{segment}/.
 * Same pattern as employers: list definitions in *Resources.js, use these for URLs + UI items.
 */

const publicBase = process.env.PUBLIC_URL || '';

/**
 * Full URL for one file in a resources subfolder.
 * @param {string} segment - folder name under public/resources (e.g. 'employers', 'parents')
 * @param {string} filename - exact filename on disk (spaces/special chars encoded)
 */
export function resourceFolderFileUrl(segment, filename) {
  return `${publicBase}/resources/${segment}/${encodeURIComponent(filename)}`;
}

/**
 * @typedef {{ id: string, title: string, description?: string, filename: string, icon?: string }} FolderResourceFileDef
 */

/**
 * Map file definitions to Resources page cards (href + metadata).
 * @param {string} segment
 * @param {FolderResourceFileDef[]} fileDefinitions
 */
export function getFolderResourceItems(segment, fileDefinitions) {
  return (fileDefinitions || []).map((f) => ({
    id: f.id,
    title: f.title,
    description: f.description ?? '',
    href: resourceFolderFileUrl(segment, f.filename),
    icon: f.icon || '📄',
  }));
}
